var $be219b4f0a2c4a58$exports = {};
$be219b4f0a2c4a58$exports = {
    "clear": `Jasen`,
    "invalid": `(neveljavno)`,
    "loading": `Nalaganje...`,
    "noResults": `Ni rezultatov`
};


export {$be219b4f0a2c4a58$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
